import { ReactNode } from 'react';
import { Validators } from '../../../config/constants';
import useToastState from '../../../context/toast/useToastState';
import { validateErrors } from '../../../helpers';

type ClosePositionWrapperProps<T> = {
    component: React.FC<T>;
    props: Omit<T, 'children'>;
    children(confirm: {
        confirm: () => Promise<void>;
        validate: () => boolean;
    }): ReactNode;
};

type ClosePositionTypeBaseProps = {
    children(confirm: {
        confirm: () => Promise<void>;
        validators: Validators[];
    }): ReactNode;
};

const ClosePositionWrapper = <T extends ClosePositionTypeBaseProps>({
    component: Component,
    children,
    props,
}: ClosePositionWrapperProps<T>) => {
    const { setToast } = useToastState();

    return (
        <Component {...(props as T)}>
            {({ confirm, validators }) =>
                children({
                    confirm,
                    validate: () =>
                        validateErrors(validators, (message) =>
                            setToast(
                                {
                                    message,
                                    type: 'danger',
                                },
                                message
                            )
                        ),
                })
            }
        </Component>
    );
};

export default ClosePositionWrapper;
